import { createReducer } from '@reduxjs/toolkit';
import dayjs, { Dayjs } from 'dayjs';
import { RESET_AMWELL_ACTIVITY } from '../activeConsumer/actions';
import { ActivityStatus } from './types';
import { SET_ACTIVITY_STATUS, SET_NEW_STARTED_FLOW_TIME_STAMP } from './actions';

export type ActivityState = Readonly<{
  status: ActivityStatus;
  startedFlowTimeStamp: Dayjs | null;
}>;

export const activityInitialState: ActivityState = {
  status: ActivityStatus.INACTIVE,
  startedFlowTimeStamp: null
};

/**
 * Amwell User Activity
 * @desc Tracks user activity for ConnectCareVisitActivity
 */

export const activityReducer = createReducer(activityInitialState, {
  [SET_ACTIVITY_STATUS]: (state, action) => {
    state.status = action.payload;
  },
  [SET_NEW_STARTED_FLOW_TIME_STAMP]: state => {
    state.startedFlowTimeStamp = dayjs();
  },
  [RESET_AMWELL_ACTIVITY]: () => activityInitialState
});
